import {
  RoomEntity,
  RoomEntityRaw,
  RoomV2Entity,
  RoomV2EntityRaw
} from "@common/domain";
import {
  RoomMixerJson,
  RoomMixerVO,
  RoomStreamVO,
  RoomStreamVORaw
} from "@youm-front/room/domain";

export function buildRoomMixerVO(roomMixerJson: RoomMixerJson): RoomMixerVO {
  return new RoomMixerVO(roomMixerJson);
}

export function buildRoomEntity(roomEntityRaw: RoomEntityRaw): RoomEntity {
  return new RoomEntity(roomEntityRaw);
}

export function buildRoomEntityV2(data: RoomV2EntityRaw): RoomV2Entity {
  return new RoomV2Entity(data);
}

export function buildRoomStreamVO(
  roomStreamVORaw: RoomStreamVORaw
): RoomStreamVO {
  return new RoomStreamVO(roomStreamVORaw);
}
